import { MainContainer } from "components/common";
import { MarqueeContainer, TechPartnersWrapper, Title } from "./element";
import Marquee from "react-fast-marquee";
import { marqueeData } from "./data";
import { Image } from "react-bootstrap";
import { useState } from "react";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
function TechPartnersCom() {
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };
  return (
    <TechPartnersWrapper>
      <MainContainer>
        <AnimationOnScroll animateIn="animate__bounceIn">
          <Title>Tech Partners</Title>
        </AnimationOnScroll>
        <MarqueeContainer>
          <Marquee pauseOnHover={true}>
            {marqueeData?.map((item) => (
              <div
                key={item.id}
                className="image-wrapper"
                onMouseEnter={() => handleMouseEnter(item)}
                onMouseLeave={handleMouseLeave}
              >
                <Image
                  // src={hoveredItem === item ? item.hoverImage : item.image}
                  src={item.hoverImage}
                  width={255}
                  height={57}
                  style={{ objectFit: "contain" }}
                />
              </div>
            ))}
          </Marquee>
        </MarqueeContainer>
      </MainContainer>
    </TechPartnersWrapper>
  );
}

export default TechPartnersCom;
